var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPublish = function SvgPublish(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "Publish_svg__a",
    width: 24,
    height: 24,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h24v24H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#Publish_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11 20v-8.15l-2.6 2.6L7 13l5-5 5 5-1.4 1.45-2.6-2.6V20zM4 9V6q0-.824.588-1.412A1.93 1.93 0 0 1 6 4h12q.824 0 1.413.588Q20 5.175 20 6v3h-2V6H6v3z"
  }))));
};
export { SvgPublish as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMWVtIiBoZWlnaHQ9IjFlbSIgdmlld0JveD0iMCAwIDI0IDI0IiBmaWxsPSJjdXJyZW50Q29sb3IiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxtYXNrIGlkPSJtYXNrMF8xMjkwM18xNTY1MDgiIHN0eWxlPSJtYXNrLXR5cGU6YWxwaGEiIG1hc2tVbml0cz0idXNlclNwYWNlT25Vc2UiIHg9IjAiIHk9IjAiIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCI+CjxyZWN0IHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgZmlsbD0iI0Q5RDlEOSIvPgo8L21hc2s+CjxnIG1hc2s9InVybCgjbWFzazBfMTI5MDNfMTU2NTA4KSI+CjxwYXRoIGQ9Ik0xMSAyMFYxMS44NUw4LjQgMTQuNDVMNyAxM0wxMiA4TDE3IDEzTDE1LjYgMTQuNDVMMTMgMTEuODVWMjBIMTFaTTQgOVY2QzQgNS40NSA0LjE5NTgzIDQuOTc5MTcgNC41ODc1IDQuNTg3NUM0Ljk3OTE3IDQuMTk1ODMgNS40NSA0IDYgNEgxOEMxOC41NSA0IDE5LjAyMDggNC4xOTU4MyAxOS40MTI1IDQuNTg3NUMxOS44MDQyIDQuOTc5MTcgMjAgNS40NSAyMCA2VjlIMThWNkg2VjlINFoiIGZpbGw9ImN1cnJlbnRDb2xvciIvPgo8L2c+Cjwvc3ZnPgo=";